import App from './App';
import * as serviceWorker from './serviceWorker';

import * as Sentry from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom';

// Monitoramento de erros (GlitchTip/Sentry). Sem DSN, não inicializa.
// tracesSampleRate em 0 porque o GlitchTip não suporta performance tracing completo.
if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV || 'production',
    tracesSampleRate: 0,
    initialScope: {
      tags: { app: 'website' },
    },
  });
}

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
